import _ from 'underscore';

import { getSessionManagementServiceInstance } from '../../../sessionManagement/SessionManagementService';
import { SiteRoles } from '../../../ts/ServerApi/types/ISiteRole';

// TODO: hook this up in a bunch of other places.
export class SiteRolesResource {

  private static All = [
    SiteRoles.ServerAdministrator,
    SiteRoles.SiteAdministratorCreator,
    SiteRoles.SiteAdministratorExplorer,
    SiteRoles.SupportUser,
    SiteRoles.Creator,
    SiteRoles.ExplorerCanPublish,
    SiteRoles.Explorer,
    SiteRoles.Viewer,
    SiteRoles.Unlicensed,
    SiteRoles.Guest
  ];

  public static Mixed = 'Mixed';
  public static LocPrefix = 'siteRole_';
  public static Explorer = 'Explorer';
  public static AnyRole = 'Any';

  public static readonly instance = new SiteRolesResource();

  public allOptions(): string[] {
    return SiteRolesResource.All;
  }

  public optionsForCurrentUser(): string[] {
    const sessionManagementService = getSessionManagementServiceInstance();
    const rolesToRemoveFromList = [ SiteRoles.SupportUser, SiteRoles.Guest ];
    if (!sessionManagementService.isSessionServerAdmin()) {
      rolesToRemoveFromList.push(SiteRoles.ServerAdministrator);
    }
    return _.difference(this.allOptions(), rolesToRemoveFromList);
  }

  public optionsForCurrentUserExcept(...rolesToExclude: string[]): string[] {
    return _.difference(this.optionsForCurrentUser(), rolesToExclude);
  }

  public getProjectOwnershipRoles(): string[] {
    return this.getExplorerCanPublishAndAboveRoles();
  }

  public getMetricOwnershipRoles(): string[] {
    return this.getExplorerCanPublishAndAboveRoles();
  }

  private getExplorerCanPublishAndAboveRoles(): string[] {
    const serverService = getSessionManagementServiceInstance();
    let ownershipRoles = [
      SiteRoles.ServerAdministrator,
      SiteRoles.SiteAdministratorExplorer,
      SiteRoles.SupportUser,
      SiteRoles.ExplorerCanPublish
    ];
    if (serverService.hasCreatorTier()) {
      ownershipRoles = ownershipRoles.concat([SiteRoles.SiteAdministratorCreator, SiteRoles.Creator]);
    }

    return ownershipRoles;
  }

  public getAdminRoles(): string[] {
    const serverService = getSessionManagementServiceInstance();
    return _.compact([
        SiteRoles.ServerAdministrator,
        serverService.hasCreatorTier() && SiteRoles.SiteAdministratorCreator,
        SiteRoles.SiteAdministratorExplorer,
        SiteRoles.SupportUser
    ]);
  }
}
export default SiteRolesResource.instance;